import { Box } from "@chakra-ui/react";
import {
  Button,
  ChevronDownIcon,
  MenuList,
  useBooleanState,
} from "@verivest/shared-components";
import React from "react";

interface WhiteLabelSortByProps {
  activeSort: string;
}
export const WhiteLabelSortBy: React.FC<WhiteLabelSortByProps> = ({
  children,
  activeSort,
}) => {
  const filterState = useBooleanState(false);
  return (
    <Box className={"relative mt-1"}>
      Sort by{" "}
      <Button
        textProps={{
          textDecoration: "none",
        }}
        link
        onClick={filterState.toggle}
        display="inline-block"
      >
        {activeSort}{" "}
        <ChevronDownIcon
          color="text.grey"
          transform={filterState.state ? "rotate(-180deg)" : undefined}
        />
      </Button>
      {filterState.state && (
        <MenuList
          right={0}
          position="absolute"
          onClick={filterState.toggle}
          zIndex={"dropdown"}
        >
          {children}
        </MenuList>
      )}
    </Box>
  );
};
